import { render, staticRenderFns } from "./Input_Message.vue?vue&type=template&id=a885db44&scoped=true&"
import script from "./Input_Message.vue?vue&type=script&lang=js&"
export * from "./Input_Message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a885db44",
  null
  
)

export default component.exports